// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/detailed-product-card-exchange/detailed-product-card-exchange.component.scss
// module id = 264
// module chunks = 0